import { ReactComponentManifest } from "web/entrypoints/common/setup";
import AdsenseShopping from "web/react/components/adsense-shopping/adsense-shopping";
import HomepageLayout from "web/react/components/homepage-layout/homepage-layout";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    AdsenseShopping: withRedux(AdsenseShopping),
    HomepageLayout,
};

export default components;
